import { defineStore } from "pinia";
import _filter from "lodash/filter";
import { useForm } from "@/form";

export const useStore = defineStore("requiredSettings", {
    state: () => {
        return {
            requiredSettingsData: [],
        };
    },

    getters: {
        hasMissingRequiredSettings: (state) => {
            return _filter(state.requiredSettingsData, (value, key) => !value).length > 0;
        },
    },

    actions: {
        async fetchRequiredSettings() {
            try {
                const response = await useForm().post("auth_required_settings");
                this.requiredSettingsData = response;
            } catch (error) {
                return error;
            }
        },

        async refresh() {
            await this.fetchRequiredSettings();
        },
    },
});
